/* KASTENKISTE · Video-Popup (Mess-Anleitung etc.)
   Nutzung im Text:  <a href="#" data-kk-video="YOUTUBE-ID-oder-URL" data-kk-titel="So misst du aus">klick hier, so misst du aus</a>
   Lokales Video:     data-kk-video="https://.../datei.mp4" data-kk-typ="mp4"
   Aus JS (Konfigurator/Finder):  kkVideo('YTID', 'yt', 'So misst du aus') */
(function(){
  'use strict';
  var modal, medien, titelEl, offen=false, letzterFokus=null;
  function bauen(){
    if(modal) return;
    var s=document.createElement('style');
    s.textContent=".kk-vp{position:fixed;inset:0;z-index:9999;display:none;align-items:center;justify-content:center;background:rgba(10,10,10,.82);padding:20px}"+
    ".kk-vp.auf{display:flex}"+
    ".kk-vp__box{position:relative;width:min(960px,100%);background:#0a0a0a;border-radius:14px;overflow:hidden;box-shadow:0 20px 60px rgba(0,0,0,.5)}"+
    ".kk-vp__titel{color:#fff;font-family:'Bebas Neue',Impact,sans-serif;letter-spacing:.5px;font-size:20px;padding:14px 54px 10px 18px}"+
    ".kk-vp__medien{position:relative;width:100%;aspect-ratio:16/9;background:#000}"+
    ".kk-vp__medien iframe,.kk-vp__medien video{position:absolute;inset:0;width:100%;height:100%;border:0}"+
    ".kk-vp__zu{position:absolute;top:8px;right:8px;z-index:2;width:40px;height:40px;border:0;border-radius:50%;background:var(--kk-gelb,#f5c400);color:#0a0a0a;font-size:22px;line-height:1;cursor:pointer}";
    document.head.appendChild(s);
    modal=document.createElement('div');
    modal.className='kk-vp';
    modal.setAttribute('role','dialog');
    modal.setAttribute('aria-modal','true');
    modal.innerHTML='<div class="kk-vp__box"><button class="kk-vp__zu" aria-label="Schliessen">&times;</button><div class="kk-vp__titel" data-vp-titel></div><div class="kk-vp__medien" data-vp-medien></div></div>';
    document.body.appendChild(modal);
    medien=modal.querySelector('[data-vp-medien]');
    titelEl=modal.querySelector('[data-vp-titel]');
    modal.addEventListener('click',function(e){ if(e.target===modal) zu(); });
    modal.querySelector('.kk-vp__zu').addEventListener('click',zu);
    document.addEventListener('keydown',function(e){ if(offen && e.key==='Escape') zu(); });
  }
  function ytId(v){
    v=(v||'').trim();
    var m=v.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/))([\w-]{11})/);
    if(m) return m[1];
    if(/^[\w-]{11}$/.test(v)) return v;
    return '';
  }
  function auf(v,typ,titel){
    bauen();
    var html='';
    if(typ==='mp4' || /\.(mp4|webm|mov)(\?|$)/i.test(v)){
      html='<video controls autoplay playsinline src="'+v+'"></video>';
    } else {
      var id=ytId(v);
      if(id){ html='<iframe src="https://www.youtube-nocookie.com/embed/'+id+'?autoplay=1&rel=0" title="Video" allow="autoplay; encrypted-media; fullscreen" allowfullscreen></iframe>'; }
      else { html='<video controls autoplay playsinline src="'+v+'"></video>'; }
    }
    medien.innerHTML=html;
    titelEl.textContent=titel||'';
    titelEl.style.display=titel?'block':'none';
    modal.classList.add('auf');
    offen=true;
    letzterFokus=document.activeElement;
    modal.querySelector('.kk-vp__zu').focus();
  }
  function zu(){
    if(!modal) return;
    modal.classList.remove('auf');
    medien.innerHTML='';
    offen=false;
    if(letzterFokus && letzterFokus.focus) letzterFokus.focus();
  }
  document.addEventListener('click',function(e){
    var t=e.target && e.target.closest ? e.target.closest('[data-kk-video]') : null;
    if(!t) return;
    e.preventDefault();
    auf(t.getAttribute('data-kk-video'), t.getAttribute('data-kk-typ'), t.getAttribute('data-kk-titel'));
  });
  window.kkVideo=auf;
})();
